/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as R404RouteImport } from './../routes/404'
import { Route as R503RouteImport } from './../routes/503'
import { Route as ArchiveRouteRouteImport } from './../routes/archive/route'
import { Route as ChangelogRouteImport } from './../routes/changelog'
import { Route as InvalidProjectRouteImport } from './../routes/invalid-project'
import { Route as LoginRouteImport } from './../routes/login'
import { Route as MonitorRouteImport } from './../routes/monitor'
import { Route as NoProjectsRouteImport } from './../routes/no-projects'
import { Route as ProjectsRouteImport } from './../routes/projects'
import { Route as QualityAgentRouteImport } from './../routes/quality-agent'
import { Route as SimsearchRouteRouteImport } from './../routes/simsearch/route'
import { Route as ArchiveIndexRouteImport } from './../routes/archive/index'
import { Route as ArchiveImageRouteImport } from './../routes/archive/image'
import { Route as AuthCallbackRouteImport } from './../routes/auth/callback'
import { Route as DeployIndexRouteImport } from './../routes/deploy/index'
import { Route as HeatmapIndexRouteImport } from './../routes/heatmap/index'
import { Route as ModelIndexRouteImport } from './../routes/model/index'
import { Route as ModelAddSamplesRouteRouteImport } from './../routes/model/add-samples/route'
import { Route as ModelFinetuneRouteRouteImport } from './../routes/model/finetune/route'
import { Route as ModelSamplesRouteRouteImport } from './../routes/model/samples/route'
import { Route as ModelSettingsRouteImport } from './../routes/model/settings'
import { Route as ModelTrainingRouteImport } from './../routes/model/training'
import { Route as ModelsIndexRouteImport } from './../routes/models/index'
import { Route as ModelsNewRouteImport } from './../routes/models/new'
import { Route as SettingsIndexRouteImport } from './../routes/settings/index'
import { Route as SettingsAdminConfigRouteImport } from './../routes/settings/adminConfig'
import { Route as SettingsApiTokensRouteImport } from './../routes/settings/apiTokens'
import { Route as SettingsAutomaticReportsRouteImport } from './../routes/settings/automaticReports'
import { Route as SettingsDevicesRouteImport } from './../routes/settings/devices'
import { Route as SettingsGeneralRouteImport } from './../routes/settings/general'
import { Route as SettingsNotificationsRouteImport } from './../routes/settings/notifications'
import { Route as SettingsPerspectivesRouteImport } from './../routes/settings/perspectives'
import { Route as SettingsShiftsRouteImport } from './../routes/settings/shifts'
import { Route as SettingsUsersRouteImport } from './../routes/settings/users'
import { Route as SimsearchIndexRouteImport } from './../routes/simsearch/index'
import { Route as SimsearchImageRouteImport } from './../routes/simsearch/image'
import { Route as TasksIndexRouteImport } from './../routes/tasks/index'
import { Route as TasksLiveSessionRouteImport } from './../routes/tasks/live-session'
import { Route as TasksSessionRouteImport } from './../routes/tasks/session'
import { Route as ModelModelIdMeasuringRouteImport } from './../routes/model/$modelId/measuring'
import { Route as ModelAddSamplesIndexRouteImport } from './../routes/model/add-samples/index'
import { Route as ModelAddSamplesImageRouteImport } from './../routes/model/add-samples/image'
import { Route as ModelFinetuneIndexRouteImport } from './../routes/model/finetune/index'
import { Route as ModelFinetuneDeploymentSettingsRouteImport } from './../routes/model/finetune/deployment-settings'
import { Route as ModelFinetuneGenerateDataLoadingRouteImport } from './../routes/model/finetune/generate-data-loading'
import { Route as ModelFinetuneGenerateDataSuccessRouteImport } from './../routes/model/finetune/generate-data-success'
import { Route as ModelFinetuneImageRouteImport } from './../routes/model/finetune/image'
import { Route as ModelFinetuneImproveDatasetRouteImport } from './../routes/model/finetune/improve-dataset'
import { Route as ModelFinetuneImproveDatasetLoadingRouteImport } from './../routes/model/finetune/improve-dataset-loading'
import { Route as ModelSamplesIndexRouteImport } from './../routes/model/samples/index'
import { Route as ModelSamplesDefectStudioRouteImport } from './../routes/model/samples/defect-studio'
import { Route as ModelSamplesImageRouteImport } from './../routes/model/samples/image'
import { Route as ModelSamplesSmartSelectRouteImport } from './../routes/model/samples/smart-select'
import { Route as ModelSamplesSmartSelectResultsRouteImport } from './../routes/model/samples/smart-select-results'
import { Route as ModelStatisticsIndexRouteImport } from './../routes/model/statistics/index'
import { Route as ModelStatisticsLabelDistributionRouteImport } from './../routes/model/statistics/label-distribution'
import { Route as ModelStatisticsLabelNoiseRouteImport } from './../routes/model/statistics/label-noise'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const R503Route = R503RouteImport.update({
  id: '/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveRouteRoute = ArchiveRouteRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const InvalidProjectRoute = InvalidProjectRouteImport.update({
  id: '/invalid-project',
  path: '/invalid-project',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MonitorRoute = MonitorRouteImport.update({
  id: '/monitor',
  path: '/monitor',
  getParentRoute: () => rootRouteImport,
} as any)
const NoProjectsRoute = NoProjectsRouteImport.update({
  id: '/no-projects',
  path: '/no-projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const QualityAgentRoute = QualityAgentRouteImport.update({
  id: '/quality-agent',
  path: '/quality-agent',
  getParentRoute: () => rootRouteImport,
} as any)
const SimsearchRouteRoute = SimsearchRouteRouteImport.update({
  id: '/simsearch',
  path: '/simsearch',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveIndexRoute = ArchiveIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArchiveRouteRoute,
} as any)
const ArchiveImageRoute = ArchiveImageRouteImport.update({
  id: '/image',
  path: '/image',
  getParentRoute: () => ArchiveRouteRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DeployIndexRoute = DeployIndexRouteImport.update({
  id: '/deploy/',
  path: '/deploy/',
  getParentRoute: () => rootRouteImport,
} as any)
const HeatmapIndexRoute = HeatmapIndexRouteImport.update({
  id: '/heatmap/',
  path: '/heatmap/',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelIndexRoute = ModelIndexRouteImport.update({
  id: '/model/',
  path: '/model/',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelAddSamplesRouteRoute = ModelAddSamplesRouteRouteImport.update({
  id: '/model/add-samples',
  path: '/model/add-samples',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelFinetuneRouteRoute = ModelFinetuneRouteRouteImport.update({
  id: '/model/finetune',
  path: '/model/finetune',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelSamplesRouteRoute = ModelSamplesRouteRouteImport.update({
  id: '/model/samples',
  path: '/model/samples',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelSettingsRoute = ModelSettingsRouteImport.update({
  id: '/model/settings',
  path: '/model/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelTrainingRoute = ModelTrainingRouteImport.update({
  id: '/model/training',
  path: '/model/training',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelsIndexRoute = ModelsIndexRouteImport.update({
  id: '/models/',
  path: '/models/',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelsNewRoute = ModelsNewRouteImport.update({
  id: '/models/new',
  path: '/models/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAdminConfigRoute = SettingsAdminConfigRouteImport.update({
  id: '/settings/adminConfig',
  path: '/settings/adminConfig',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApiTokensRoute = SettingsApiTokensRouteImport.update({
  id: '/settings/apiTokens',
  path: '/settings/apiTokens',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAutomaticReportsRoute =
  SettingsAutomaticReportsRouteImport.update({
    id: '/settings/automaticReports',
    path: '/settings/automaticReports',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsDevicesRoute = SettingsDevicesRouteImport.update({
  id: '/settings/devices',
  path: '/settings/devices',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/settings/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPerspectivesRoute = SettingsPerspectivesRouteImport.update({
  id: '/settings/perspectives',
  path: '/settings/perspectives',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsShiftsRoute = SettingsShiftsRouteImport.update({
  id: '/settings/shifts',
  path: '/settings/shifts',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SimsearchIndexRoute = SimsearchIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SimsearchRouteRoute,
} as any)
const SimsearchImageRoute = SimsearchImageRouteImport.update({
  id: '/image',
  path: '/image',
  getParentRoute: () => SimsearchRouteRoute,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksLiveSessionRoute = TasksLiveSessionRouteImport.update({
  id: '/tasks/live-session',
  path: '/tasks/live-session',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksSessionRoute = TasksSessionRouteImport.update({
  id: '/tasks/session',
  path: '/tasks/session',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelModelIdMeasuringRoute = ModelModelIdMeasuringRouteImport.update({
  id: '/model/$modelId/measuring',
  path: '/model/$modelId/measuring',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelAddSamplesIndexRoute = ModelAddSamplesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ModelAddSamplesRouteRoute,
} as any)
const ModelAddSamplesImageRoute = ModelAddSamplesImageRouteImport.update({
  id: '/image',
  path: '/image',
  getParentRoute: () => ModelAddSamplesRouteRoute,
} as any)
const ModelFinetuneIndexRoute = ModelFinetuneIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ModelFinetuneRouteRoute,
} as any)
const ModelFinetuneDeploymentSettingsRoute =
  ModelFinetuneDeploymentSettingsRouteImport.update({
    id: '/deployment-settings',
    path: '/deployment-settings',
    getParentRoute: () => ModelFinetuneRouteRoute,
  } as any)
const ModelFinetuneGenerateDataLoadingRoute =
  ModelFinetuneGenerateDataLoadingRouteImport.update({
    id: '/generate-data-loading',
    path: '/generate-data-loading',
    getParentRoute: () => ModelFinetuneRouteRoute,
  } as any)
const ModelFinetuneGenerateDataSuccessRoute =
  ModelFinetuneGenerateDataSuccessRouteImport.update({
    id: '/generate-data-success',
    path: '/generate-data-success',
    getParentRoute: () => ModelFinetuneRouteRoute,
  } as any)
const ModelFinetuneImageRoute = ModelFinetuneImageRouteImport.update({
  id: '/image',
  path: '/image',
  getParentRoute: () => ModelFinetuneRouteRoute,
} as any)
const ModelFinetuneImproveDatasetRoute =
  ModelFinetuneImproveDatasetRouteImport.update({
    id: '/improve-dataset',
    path: '/improve-dataset',
    getParentRoute: () => ModelFinetuneRouteRoute,
  } as any)
const ModelFinetuneImproveDatasetLoadingRoute =
  ModelFinetuneImproveDatasetLoadingRouteImport.update({
    id: '/improve-dataset-loading',
    path: '/improve-dataset-loading',
    getParentRoute: () => ModelFinetuneRouteRoute,
  } as any)
const ModelSamplesIndexRoute = ModelSamplesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ModelSamplesRouteRoute,
} as any)
const ModelSamplesDefectStudioRoute =
  ModelSamplesDefectStudioRouteImport.update({
    id: '/defect-studio',
    path: '/defect-studio',
    getParentRoute: () => ModelSamplesRouteRoute,
  } as any)
const ModelSamplesImageRoute = ModelSamplesImageRouteImport.update({
  id: '/image',
  path: '/image',
  getParentRoute: () => ModelSamplesRouteRoute,
} as any)
const ModelSamplesSmartSelectRoute = ModelSamplesSmartSelectRouteImport.update({
  id: '/smart-select',
  path: '/smart-select',
  getParentRoute: () => ModelSamplesRouteRoute,
} as any)
const ModelSamplesSmartSelectResultsRoute =
  ModelSamplesSmartSelectResultsRouteImport.update({
    id: '/smart-select-results',
    path: '/smart-select-results',
    getParentRoute: () => ModelSamplesRouteRoute,
  } as any)
const ModelStatisticsIndexRoute = ModelStatisticsIndexRouteImport.update({
  id: '/model/statistics/',
  path: '/model/statistics/',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelStatisticsLabelDistributionRoute =
  ModelStatisticsLabelDistributionRouteImport.update({
    id: '/model/statistics/label-distribution',
    path: '/model/statistics/label-distribution',
    getParentRoute: () => rootRouteImport,
  } as any)
const ModelStatisticsLabelNoiseRoute =
  ModelStatisticsLabelNoiseRouteImport.update({
    id: '/model/statistics/label-noise',
    path: '/model/statistics/label-noise',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRouteRouteWithChildren
  '/simsearch': typeof SimsearchRouteRouteWithChildren
  '/404': typeof R404Route
  '/503': typeof R503Route
  '/changelog': typeof ChangelogRoute
  '/invalid-project': typeof InvalidProjectRoute
  '/login': typeof LoginRoute
  '/monitor': typeof MonitorRoute
  '/no-projects': typeof NoProjectsRoute
  '/projects': typeof ProjectsRoute
  '/quality-agent': typeof QualityAgentRoute
  '/model/add-samples': typeof ModelAddSamplesRouteRouteWithChildren
  '/model/finetune': typeof ModelFinetuneRouteRouteWithChildren
  '/model/samples': typeof ModelSamplesRouteRouteWithChildren
  '/archive/image': typeof ArchiveImageRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/model/settings': typeof ModelSettingsRoute
  '/model/training': typeof ModelTrainingRoute
  '/models/new': typeof ModelsNewRoute
  '/settings/adminConfig': typeof SettingsAdminConfigRoute
  '/settings/apiTokens': typeof SettingsApiTokensRoute
  '/settings/automaticReports': typeof SettingsAutomaticReportsRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/perspectives': typeof SettingsPerspectivesRoute
  '/settings/shifts': typeof SettingsShiftsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/simsearch/image': typeof SimsearchImageRoute
  '/tasks/live-session': typeof TasksLiveSessionRoute
  '/tasks/session': typeof TasksSessionRoute
  '/archive/': typeof ArchiveIndexRoute
  '/deploy/': typeof DeployIndexRoute
  '/heatmap/': typeof HeatmapIndexRoute
  '/model/': typeof ModelIndexRoute
  '/models/': typeof ModelsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/simsearch/': typeof SimsearchIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/model/$modelId/measuring': typeof ModelModelIdMeasuringRoute
  '/model/add-samples/image': typeof ModelAddSamplesImageRoute
  '/model/finetune/deployment-settings': typeof ModelFinetuneDeploymentSettingsRoute
  '/model/finetune/generate-data-loading': typeof ModelFinetuneGenerateDataLoadingRoute
  '/model/finetune/generate-data-success': typeof ModelFinetuneGenerateDataSuccessRoute
  '/model/finetune/image': typeof ModelFinetuneImageRoute
  '/model/finetune/improve-dataset': typeof ModelFinetuneImproveDatasetRoute
  '/model/finetune/improve-dataset-loading': typeof ModelFinetuneImproveDatasetLoadingRoute
  '/model/samples/defect-studio': typeof ModelSamplesDefectStudioRoute
  '/model/samples/image': typeof ModelSamplesImageRoute
  '/model/samples/smart-select': typeof ModelSamplesSmartSelectRoute
  '/model/samples/smart-select-results': typeof ModelSamplesSmartSelectResultsRoute
  '/model/statistics/label-distribution': typeof ModelStatisticsLabelDistributionRoute
  '/model/statistics/label-noise': typeof ModelStatisticsLabelNoiseRoute
  '/model/add-samples/': typeof ModelAddSamplesIndexRoute
  '/model/finetune/': typeof ModelFinetuneIndexRoute
  '/model/samples/': typeof ModelSamplesIndexRoute
  '/model/statistics/': typeof ModelStatisticsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/503': typeof R503Route
  '/changelog': typeof ChangelogRoute
  '/invalid-project': typeof InvalidProjectRoute
  '/login': typeof LoginRoute
  '/monitor': typeof MonitorRoute
  '/no-projects': typeof NoProjectsRoute
  '/projects': typeof ProjectsRoute
  '/quality-agent': typeof QualityAgentRoute
  '/archive/image': typeof ArchiveImageRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/model/settings': typeof ModelSettingsRoute
  '/model/training': typeof ModelTrainingRoute
  '/models/new': typeof ModelsNewRoute
  '/settings/adminConfig': typeof SettingsAdminConfigRoute
  '/settings/apiTokens': typeof SettingsApiTokensRoute
  '/settings/automaticReports': typeof SettingsAutomaticReportsRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/perspectives': typeof SettingsPerspectivesRoute
  '/settings/shifts': typeof SettingsShiftsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/simsearch/image': typeof SimsearchImageRoute
  '/tasks/live-session': typeof TasksLiveSessionRoute
  '/tasks/session': typeof TasksSessionRoute
  '/archive': typeof ArchiveIndexRoute
  '/deploy': typeof DeployIndexRoute
  '/heatmap': typeof HeatmapIndexRoute
  '/model': typeof ModelIndexRoute
  '/models': typeof ModelsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/simsearch': typeof SimsearchIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/model/$modelId/measuring': typeof ModelModelIdMeasuringRoute
  '/model/add-samples/image': typeof ModelAddSamplesImageRoute
  '/model/finetune/deployment-settings': typeof ModelFinetuneDeploymentSettingsRoute
  '/model/finetune/generate-data-loading': typeof ModelFinetuneGenerateDataLoadingRoute
  '/model/finetune/generate-data-success': typeof ModelFinetuneGenerateDataSuccessRoute
  '/model/finetune/image': typeof ModelFinetuneImageRoute
  '/model/finetune/improve-dataset': typeof ModelFinetuneImproveDatasetRoute
  '/model/finetune/improve-dataset-loading': typeof ModelFinetuneImproveDatasetLoadingRoute
  '/model/samples/defect-studio': typeof ModelSamplesDefectStudioRoute
  '/model/samples/image': typeof ModelSamplesImageRoute
  '/model/samples/smart-select': typeof ModelSamplesSmartSelectRoute
  '/model/samples/smart-select-results': typeof ModelSamplesSmartSelectResultsRoute
  '/model/statistics/label-distribution': typeof ModelStatisticsLabelDistributionRoute
  '/model/statistics/label-noise': typeof ModelStatisticsLabelNoiseRoute
  '/model/add-samples': typeof ModelAddSamplesIndexRoute
  '/model/finetune': typeof ModelFinetuneIndexRoute
  '/model/samples': typeof ModelSamplesIndexRoute
  '/model/statistics': typeof ModelStatisticsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRouteRouteWithChildren
  '/simsearch': typeof SimsearchRouteRouteWithChildren
  '/404': typeof R404Route
  '/503': typeof R503Route
  '/changelog': typeof ChangelogRoute
  '/invalid-project': typeof InvalidProjectRoute
  '/login': typeof LoginRoute
  '/monitor': typeof MonitorRoute
  '/no-projects': typeof NoProjectsRoute
  '/projects': typeof ProjectsRoute
  '/quality-agent': typeof QualityAgentRoute
  '/model/add-samples': typeof ModelAddSamplesRouteRouteWithChildren
  '/model/finetune': typeof ModelFinetuneRouteRouteWithChildren
  '/model/samples': typeof ModelSamplesRouteRouteWithChildren
  '/archive/image': typeof ArchiveImageRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/model/settings': typeof ModelSettingsRoute
  '/model/training': typeof ModelTrainingRoute
  '/models/new': typeof ModelsNewRoute
  '/settings/adminConfig': typeof SettingsAdminConfigRoute
  '/settings/apiTokens': typeof SettingsApiTokensRoute
  '/settings/automaticReports': typeof SettingsAutomaticReportsRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/perspectives': typeof SettingsPerspectivesRoute
  '/settings/shifts': typeof SettingsShiftsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/simsearch/image': typeof SimsearchImageRoute
  '/tasks/live-session': typeof TasksLiveSessionRoute
  '/tasks/session': typeof TasksSessionRoute
  '/archive/': typeof ArchiveIndexRoute
  '/deploy/': typeof DeployIndexRoute
  '/heatmap/': typeof HeatmapIndexRoute
  '/model/': typeof ModelIndexRoute
  '/models/': typeof ModelsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/simsearch/': typeof SimsearchIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/model/$modelId/measuring': typeof ModelModelIdMeasuringRoute
  '/model/add-samples/image': typeof ModelAddSamplesImageRoute
  '/model/finetune/deployment-settings': typeof ModelFinetuneDeploymentSettingsRoute
  '/model/finetune/generate-data-loading': typeof ModelFinetuneGenerateDataLoadingRoute
  '/model/finetune/generate-data-success': typeof ModelFinetuneGenerateDataSuccessRoute
  '/model/finetune/image': typeof ModelFinetuneImageRoute
  '/model/finetune/improve-dataset': typeof ModelFinetuneImproveDatasetRoute
  '/model/finetune/improve-dataset-loading': typeof ModelFinetuneImproveDatasetLoadingRoute
  '/model/samples/defect-studio': typeof ModelSamplesDefectStudioRoute
  '/model/samples/image': typeof ModelSamplesImageRoute
  '/model/samples/smart-select': typeof ModelSamplesSmartSelectRoute
  '/model/samples/smart-select-results': typeof ModelSamplesSmartSelectResultsRoute
  '/model/statistics/label-distribution': typeof ModelStatisticsLabelDistributionRoute
  '/model/statistics/label-noise': typeof ModelStatisticsLabelNoiseRoute
  '/model/add-samples/': typeof ModelAddSamplesIndexRoute
  '/model/finetune/': typeof ModelFinetuneIndexRoute
  '/model/samples/': typeof ModelSamplesIndexRoute
  '/model/statistics/': typeof ModelStatisticsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/archive'
    | '/simsearch'
    | '/404'
    | '/503'
    | '/changelog'
    | '/invalid-project'
    | '/login'
    | '/monitor'
    | '/no-projects'
    | '/projects'
    | '/quality-agent'
    | '/model/add-samples'
    | '/model/finetune'
    | '/model/samples'
    | '/archive/image'
    | '/auth/callback'
    | '/model/settings'
    | '/model/training'
    | '/models/new'
    | '/settings/adminConfig'
    | '/settings/apiTokens'
    | '/settings/automaticReports'
    | '/settings/devices'
    | '/settings/general'
    | '/settings/notifications'
    | '/settings/perspectives'
    | '/settings/shifts'
    | '/settings/users'
    | '/simsearch/image'
    | '/tasks/live-session'
    | '/tasks/session'
    | '/archive/'
    | '/deploy/'
    | '/heatmap/'
    | '/model/'
    | '/models/'
    | '/settings/'
    | '/simsearch/'
    | '/tasks/'
    | '/model/$modelId/measuring'
    | '/model/add-samples/image'
    | '/model/finetune/deployment-settings'
    | '/model/finetune/generate-data-loading'
    | '/model/finetune/generate-data-success'
    | '/model/finetune/image'
    | '/model/finetune/improve-dataset'
    | '/model/finetune/improve-dataset-loading'
    | '/model/samples/defect-studio'
    | '/model/samples/image'
    | '/model/samples/smart-select'
    | '/model/samples/smart-select-results'
    | '/model/statistics/label-distribution'
    | '/model/statistics/label-noise'
    | '/model/add-samples/'
    | '/model/finetune/'
    | '/model/samples/'
    | '/model/statistics/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/503'
    | '/changelog'
    | '/invalid-project'
    | '/login'
    | '/monitor'
    | '/no-projects'
    | '/projects'
    | '/quality-agent'
    | '/archive/image'
    | '/auth/callback'
    | '/model/settings'
    | '/model/training'
    | '/models/new'
    | '/settings/adminConfig'
    | '/settings/apiTokens'
    | '/settings/automaticReports'
    | '/settings/devices'
    | '/settings/general'
    | '/settings/notifications'
    | '/settings/perspectives'
    | '/settings/shifts'
    | '/settings/users'
    | '/simsearch/image'
    | '/tasks/live-session'
    | '/tasks/session'
    | '/archive'
    | '/deploy'
    | '/heatmap'
    | '/model'
    | '/models'
    | '/settings'
    | '/simsearch'
    | '/tasks'
    | '/model/$modelId/measuring'
    | '/model/add-samples/image'
    | '/model/finetune/deployment-settings'
    | '/model/finetune/generate-data-loading'
    | '/model/finetune/generate-data-success'
    | '/model/finetune/image'
    | '/model/finetune/improve-dataset'
    | '/model/finetune/improve-dataset-loading'
    | '/model/samples/defect-studio'
    | '/model/samples/image'
    | '/model/samples/smart-select'
    | '/model/samples/smart-select-results'
    | '/model/statistics/label-distribution'
    | '/model/statistics/label-noise'
    | '/model/add-samples'
    | '/model/finetune'
    | '/model/samples'
    | '/model/statistics'
  id:
    | '__root__'
    | '/'
    | '/archive'
    | '/simsearch'
    | '/404'
    | '/503'
    | '/changelog'
    | '/invalid-project'
    | '/login'
    | '/monitor'
    | '/no-projects'
    | '/projects'
    | '/quality-agent'
    | '/model/add-samples'
    | '/model/finetune'
    | '/model/samples'
    | '/archive/image'
    | '/auth/callback'
    | '/model/settings'
    | '/model/training'
    | '/models/new'
    | '/settings/adminConfig'
    | '/settings/apiTokens'
    | '/settings/automaticReports'
    | '/settings/devices'
    | '/settings/general'
    | '/settings/notifications'
    | '/settings/perspectives'
    | '/settings/shifts'
    | '/settings/users'
    | '/simsearch/image'
    | '/tasks/live-session'
    | '/tasks/session'
    | '/archive/'
    | '/deploy/'
    | '/heatmap/'
    | '/model/'
    | '/models/'
    | '/settings/'
    | '/simsearch/'
    | '/tasks/'
    | '/model/$modelId/measuring'
    | '/model/add-samples/image'
    | '/model/finetune/deployment-settings'
    | '/model/finetune/generate-data-loading'
    | '/model/finetune/generate-data-success'
    | '/model/finetune/image'
    | '/model/finetune/improve-dataset'
    | '/model/finetune/improve-dataset-loading'
    | '/model/samples/defect-studio'
    | '/model/samples/image'
    | '/model/samples/smart-select'
    | '/model/samples/smart-select-results'
    | '/model/statistics/label-distribution'
    | '/model/statistics/label-noise'
    | '/model/add-samples/'
    | '/model/finetune/'
    | '/model/samples/'
    | '/model/statistics/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArchiveRouteRoute: typeof ArchiveRouteRouteWithChildren
  SimsearchRouteRoute: typeof SimsearchRouteRouteWithChildren
  R404Route: typeof R404Route
  R503Route: typeof R503Route
  ChangelogRoute: typeof ChangelogRoute
  InvalidProjectRoute: typeof InvalidProjectRoute
  LoginRoute: typeof LoginRoute
  MonitorRoute: typeof MonitorRoute
  NoProjectsRoute: typeof NoProjectsRoute
  ProjectsRoute: typeof ProjectsRoute
  QualityAgentRoute: typeof QualityAgentRoute
  ModelAddSamplesRouteRoute: typeof ModelAddSamplesRouteRouteWithChildren
  ModelFinetuneRouteRoute: typeof ModelFinetuneRouteRouteWithChildren
  ModelSamplesRouteRoute: typeof ModelSamplesRouteRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  ModelSettingsRoute: typeof ModelSettingsRoute
  ModelTrainingRoute: typeof ModelTrainingRoute
  ModelsNewRoute: typeof ModelsNewRoute
  SettingsAdminConfigRoute: typeof SettingsAdminConfigRoute
  SettingsApiTokensRoute: typeof SettingsApiTokensRoute
  SettingsAutomaticReportsRoute: typeof SettingsAutomaticReportsRoute
  SettingsDevicesRoute: typeof SettingsDevicesRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsPerspectivesRoute: typeof SettingsPerspectivesRoute
  SettingsShiftsRoute: typeof SettingsShiftsRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  TasksLiveSessionRoute: typeof TasksLiveSessionRoute
  TasksSessionRoute: typeof TasksSessionRoute
  DeployIndexRoute: typeof DeployIndexRoute
  HeatmapIndexRoute: typeof HeatmapIndexRoute
  ModelIndexRoute: typeof ModelIndexRoute
  ModelsIndexRoute: typeof ModelsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
  ModelModelIdMeasuringRoute: typeof ModelModelIdMeasuringRoute
  ModelStatisticsLabelDistributionRoute: typeof ModelStatisticsLabelDistributionRoute
  ModelStatisticsLabelNoiseRoute: typeof ModelStatisticsLabelNoiseRoute
  ModelStatisticsIndexRoute: typeof ModelStatisticsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/503': {
      id: '/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof R503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive': {
      id: '/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof ArchiveRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invalid-project': {
      id: '/invalid-project'
      path: '/invalid-project'
      fullPath: '/invalid-project'
      preLoaderRoute: typeof InvalidProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monitor': {
      id: '/monitor'
      path: '/monitor'
      fullPath: '/monitor'
      preLoaderRoute: typeof MonitorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-projects': {
      id: '/no-projects'
      path: '/no-projects'
      fullPath: '/no-projects'
      preLoaderRoute: typeof NoProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality-agent': {
      id: '/quality-agent'
      path: '/quality-agent'
      fullPath: '/quality-agent'
      preLoaderRoute: typeof QualityAgentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/simsearch': {
      id: '/simsearch'
      path: '/simsearch'
      fullPath: '/simsearch'
      preLoaderRoute: typeof SimsearchRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive/': {
      id: '/archive/'
      path: '/'
      fullPath: '/archive/'
      preLoaderRoute: typeof ArchiveIndexRouteImport
      parentRoute: typeof ArchiveRouteRoute
    }
    '/archive/image': {
      id: '/archive/image'
      path: '/image'
      fullPath: '/archive/image'
      preLoaderRoute: typeof ArchiveImageRouteImport
      parentRoute: typeof ArchiveRouteRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deploy/': {
      id: '/deploy/'
      path: '/deploy'
      fullPath: '/deploy/'
      preLoaderRoute: typeof DeployIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/heatmap/': {
      id: '/heatmap/'
      path: '/heatmap'
      fullPath: '/heatmap/'
      preLoaderRoute: typeof HeatmapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/': {
      id: '/model/'
      path: '/model'
      fullPath: '/model/'
      preLoaderRoute: typeof ModelIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/add-samples': {
      id: '/model/add-samples'
      path: '/model/add-samples'
      fullPath: '/model/add-samples'
      preLoaderRoute: typeof ModelAddSamplesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/finetune': {
      id: '/model/finetune'
      path: '/model/finetune'
      fullPath: '/model/finetune'
      preLoaderRoute: typeof ModelFinetuneRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/samples': {
      id: '/model/samples'
      path: '/model/samples'
      fullPath: '/model/samples'
      preLoaderRoute: typeof ModelSamplesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/settings': {
      id: '/model/settings'
      path: '/model/settings'
      fullPath: '/model/settings'
      preLoaderRoute: typeof ModelSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/training': {
      id: '/model/training'
      path: '/model/training'
      fullPath: '/model/training'
      preLoaderRoute: typeof ModelTrainingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/models/': {
      id: '/models/'
      path: '/models'
      fullPath: '/models/'
      preLoaderRoute: typeof ModelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/models/new': {
      id: '/models/new'
      path: '/models/new'
      fullPath: '/models/new'
      preLoaderRoute: typeof ModelsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/adminConfig': {
      id: '/settings/adminConfig'
      path: '/settings/adminConfig'
      fullPath: '/settings/adminConfig'
      preLoaderRoute: typeof SettingsAdminConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/apiTokens': {
      id: '/settings/apiTokens'
      path: '/settings/apiTokens'
      fullPath: '/settings/apiTokens'
      preLoaderRoute: typeof SettingsApiTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/automaticReports': {
      id: '/settings/automaticReports'
      path: '/settings/automaticReports'
      fullPath: '/settings/automaticReports'
      preLoaderRoute: typeof SettingsAutomaticReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/devices': {
      id: '/settings/devices'
      path: '/settings/devices'
      fullPath: '/settings/devices'
      preLoaderRoute: typeof SettingsDevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/settings/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/perspectives': {
      id: '/settings/perspectives'
      path: '/settings/perspectives'
      fullPath: '/settings/perspectives'
      preLoaderRoute: typeof SettingsPerspectivesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/shifts': {
      id: '/settings/shifts'
      path: '/settings/shifts'
      fullPath: '/settings/shifts'
      preLoaderRoute: typeof SettingsShiftsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/simsearch/': {
      id: '/simsearch/'
      path: '/'
      fullPath: '/simsearch/'
      preLoaderRoute: typeof SimsearchIndexRouteImport
      parentRoute: typeof SimsearchRouteRoute
    }
    '/simsearch/image': {
      id: '/simsearch/image'
      path: '/image'
      fullPath: '/simsearch/image'
      preLoaderRoute: typeof SimsearchImageRouteImport
      parentRoute: typeof SimsearchRouteRoute
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/live-session': {
      id: '/tasks/live-session'
      path: '/tasks/live-session'
      fullPath: '/tasks/live-session'
      preLoaderRoute: typeof TasksLiveSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/session': {
      id: '/tasks/session'
      path: '/tasks/session'
      fullPath: '/tasks/session'
      preLoaderRoute: typeof TasksSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/$modelId/measuring': {
      id: '/model/$modelId/measuring'
      path: '/model/$modelId/measuring'
      fullPath: '/model/$modelId/measuring'
      preLoaderRoute: typeof ModelModelIdMeasuringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/add-samples/': {
      id: '/model/add-samples/'
      path: '/'
      fullPath: '/model/add-samples/'
      preLoaderRoute: typeof ModelAddSamplesIndexRouteImport
      parentRoute: typeof ModelAddSamplesRouteRoute
    }
    '/model/add-samples/image': {
      id: '/model/add-samples/image'
      path: '/image'
      fullPath: '/model/add-samples/image'
      preLoaderRoute: typeof ModelAddSamplesImageRouteImport
      parentRoute: typeof ModelAddSamplesRouteRoute
    }
    '/model/finetune/': {
      id: '/model/finetune/'
      path: '/'
      fullPath: '/model/finetune/'
      preLoaderRoute: typeof ModelFinetuneIndexRouteImport
      parentRoute: typeof ModelFinetuneRouteRoute
    }
    '/model/finetune/deployment-settings': {
      id: '/model/finetune/deployment-settings'
      path: '/deployment-settings'
      fullPath: '/model/finetune/deployment-settings'
      preLoaderRoute: typeof ModelFinetuneDeploymentSettingsRouteImport
      parentRoute: typeof ModelFinetuneRouteRoute
    }
    '/model/finetune/generate-data-loading': {
      id: '/model/finetune/generate-data-loading'
      path: '/generate-data-loading'
      fullPath: '/model/finetune/generate-data-loading'
      preLoaderRoute: typeof ModelFinetuneGenerateDataLoadingRouteImport
      parentRoute: typeof ModelFinetuneRouteRoute
    }
    '/model/finetune/generate-data-success': {
      id: '/model/finetune/generate-data-success'
      path: '/generate-data-success'
      fullPath: '/model/finetune/generate-data-success'
      preLoaderRoute: typeof ModelFinetuneGenerateDataSuccessRouteImport
      parentRoute: typeof ModelFinetuneRouteRoute
    }
    '/model/finetune/image': {
      id: '/model/finetune/image'
      path: '/image'
      fullPath: '/model/finetune/image'
      preLoaderRoute: typeof ModelFinetuneImageRouteImport
      parentRoute: typeof ModelFinetuneRouteRoute
    }
    '/model/finetune/improve-dataset': {
      id: '/model/finetune/improve-dataset'
      path: '/improve-dataset'
      fullPath: '/model/finetune/improve-dataset'
      preLoaderRoute: typeof ModelFinetuneImproveDatasetRouteImport
      parentRoute: typeof ModelFinetuneRouteRoute
    }
    '/model/finetune/improve-dataset-loading': {
      id: '/model/finetune/improve-dataset-loading'
      path: '/improve-dataset-loading'
      fullPath: '/model/finetune/improve-dataset-loading'
      preLoaderRoute: typeof ModelFinetuneImproveDatasetLoadingRouteImport
      parentRoute: typeof ModelFinetuneRouteRoute
    }
    '/model/samples/': {
      id: '/model/samples/'
      path: '/'
      fullPath: '/model/samples/'
      preLoaderRoute: typeof ModelSamplesIndexRouteImport
      parentRoute: typeof ModelSamplesRouteRoute
    }
    '/model/samples/defect-studio': {
      id: '/model/samples/defect-studio'
      path: '/defect-studio'
      fullPath: '/model/samples/defect-studio'
      preLoaderRoute: typeof ModelSamplesDefectStudioRouteImport
      parentRoute: typeof ModelSamplesRouteRoute
    }
    '/model/samples/image': {
      id: '/model/samples/image'
      path: '/image'
      fullPath: '/model/samples/image'
      preLoaderRoute: typeof ModelSamplesImageRouteImport
      parentRoute: typeof ModelSamplesRouteRoute
    }
    '/model/samples/smart-select': {
      id: '/model/samples/smart-select'
      path: '/smart-select'
      fullPath: '/model/samples/smart-select'
      preLoaderRoute: typeof ModelSamplesSmartSelectRouteImport
      parentRoute: typeof ModelSamplesRouteRoute
    }
    '/model/samples/smart-select-results': {
      id: '/model/samples/smart-select-results'
      path: '/smart-select-results'
      fullPath: '/model/samples/smart-select-results'
      preLoaderRoute: typeof ModelSamplesSmartSelectResultsRouteImport
      parentRoute: typeof ModelSamplesRouteRoute
    }
    '/model/statistics/': {
      id: '/model/statistics/'
      path: '/model/statistics'
      fullPath: '/model/statistics/'
      preLoaderRoute: typeof ModelStatisticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/statistics/label-distribution': {
      id: '/model/statistics/label-distribution'
      path: '/model/statistics/label-distribution'
      fullPath: '/model/statistics/label-distribution'
      preLoaderRoute: typeof ModelStatisticsLabelDistributionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model/statistics/label-noise': {
      id: '/model/statistics/label-noise'
      path: '/model/statistics/label-noise'
      fullPath: '/model/statistics/label-noise'
      preLoaderRoute: typeof ModelStatisticsLabelNoiseRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ArchiveRouteRouteChildren {
  ArchiveImageRoute: typeof ArchiveImageRoute
  ArchiveIndexRoute: typeof ArchiveIndexRoute
}

const ArchiveRouteRouteChildren: ArchiveRouteRouteChildren = {
  ArchiveImageRoute: ArchiveImageRoute,
  ArchiveIndexRoute: ArchiveIndexRoute,
}

const ArchiveRouteRouteWithChildren = ArchiveRouteRoute._addFileChildren(
  ArchiveRouteRouteChildren,
)

interface SimsearchRouteRouteChildren {
  SimsearchImageRoute: typeof SimsearchImageRoute
  SimsearchIndexRoute: typeof SimsearchIndexRoute
}

const SimsearchRouteRouteChildren: SimsearchRouteRouteChildren = {
  SimsearchImageRoute: SimsearchImageRoute,
  SimsearchIndexRoute: SimsearchIndexRoute,
}

const SimsearchRouteRouteWithChildren = SimsearchRouteRoute._addFileChildren(
  SimsearchRouteRouteChildren,
)

interface ModelAddSamplesRouteRouteChildren {
  ModelAddSamplesImageRoute: typeof ModelAddSamplesImageRoute
  ModelAddSamplesIndexRoute: typeof ModelAddSamplesIndexRoute
}

const ModelAddSamplesRouteRouteChildren: ModelAddSamplesRouteRouteChildren = {
  ModelAddSamplesImageRoute: ModelAddSamplesImageRoute,
  ModelAddSamplesIndexRoute: ModelAddSamplesIndexRoute,
}

const ModelAddSamplesRouteRouteWithChildren =
  ModelAddSamplesRouteRoute._addFileChildren(ModelAddSamplesRouteRouteChildren)

interface ModelFinetuneRouteRouteChildren {
  ModelFinetuneDeploymentSettingsRoute: typeof ModelFinetuneDeploymentSettingsRoute
  ModelFinetuneGenerateDataLoadingRoute: typeof ModelFinetuneGenerateDataLoadingRoute
  ModelFinetuneGenerateDataSuccessRoute: typeof ModelFinetuneGenerateDataSuccessRoute
  ModelFinetuneImageRoute: typeof ModelFinetuneImageRoute
  ModelFinetuneImproveDatasetRoute: typeof ModelFinetuneImproveDatasetRoute
  ModelFinetuneImproveDatasetLoadingRoute: typeof ModelFinetuneImproveDatasetLoadingRoute
  ModelFinetuneIndexRoute: typeof ModelFinetuneIndexRoute
}

const ModelFinetuneRouteRouteChildren: ModelFinetuneRouteRouteChildren = {
  ModelFinetuneDeploymentSettingsRoute: ModelFinetuneDeploymentSettingsRoute,
  ModelFinetuneGenerateDataLoadingRoute: ModelFinetuneGenerateDataLoadingRoute,
  ModelFinetuneGenerateDataSuccessRoute: ModelFinetuneGenerateDataSuccessRoute,
  ModelFinetuneImageRoute: ModelFinetuneImageRoute,
  ModelFinetuneImproveDatasetRoute: ModelFinetuneImproveDatasetRoute,
  ModelFinetuneImproveDatasetLoadingRoute:
    ModelFinetuneImproveDatasetLoadingRoute,
  ModelFinetuneIndexRoute: ModelFinetuneIndexRoute,
}

const ModelFinetuneRouteRouteWithChildren =
  ModelFinetuneRouteRoute._addFileChildren(ModelFinetuneRouteRouteChildren)

interface ModelSamplesRouteRouteChildren {
  ModelSamplesDefectStudioRoute: typeof ModelSamplesDefectStudioRoute
  ModelSamplesImageRoute: typeof ModelSamplesImageRoute
  ModelSamplesSmartSelectRoute: typeof ModelSamplesSmartSelectRoute
  ModelSamplesSmartSelectResultsRoute: typeof ModelSamplesSmartSelectResultsRoute
  ModelSamplesIndexRoute: typeof ModelSamplesIndexRoute
}

const ModelSamplesRouteRouteChildren: ModelSamplesRouteRouteChildren = {
  ModelSamplesDefectStudioRoute: ModelSamplesDefectStudioRoute,
  ModelSamplesImageRoute: ModelSamplesImageRoute,
  ModelSamplesSmartSelectRoute: ModelSamplesSmartSelectRoute,
  ModelSamplesSmartSelectResultsRoute: ModelSamplesSmartSelectResultsRoute,
  ModelSamplesIndexRoute: ModelSamplesIndexRoute,
}

const ModelSamplesRouteRouteWithChildren =
  ModelSamplesRouteRoute._addFileChildren(ModelSamplesRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArchiveRouteRoute: ArchiveRouteRouteWithChildren,
  SimsearchRouteRoute: SimsearchRouteRouteWithChildren,
  R404Route: R404Route,
  R503Route: R503Route,
  ChangelogRoute: ChangelogRoute,
  InvalidProjectRoute: InvalidProjectRoute,
  LoginRoute: LoginRoute,
  MonitorRoute: MonitorRoute,
  NoProjectsRoute: NoProjectsRoute,
  ProjectsRoute: ProjectsRoute,
  QualityAgentRoute: QualityAgentRoute,
  ModelAddSamplesRouteRoute: ModelAddSamplesRouteRouteWithChildren,
  ModelFinetuneRouteRoute: ModelFinetuneRouteRouteWithChildren,
  ModelSamplesRouteRoute: ModelSamplesRouteRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  ModelSettingsRoute: ModelSettingsRoute,
  ModelTrainingRoute: ModelTrainingRoute,
  ModelsNewRoute: ModelsNewRoute,
  SettingsAdminConfigRoute: SettingsAdminConfigRoute,
  SettingsApiTokensRoute: SettingsApiTokensRoute,
  SettingsAutomaticReportsRoute: SettingsAutomaticReportsRoute,
  SettingsDevicesRoute: SettingsDevicesRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsPerspectivesRoute: SettingsPerspectivesRoute,
  SettingsShiftsRoute: SettingsShiftsRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  TasksLiveSessionRoute: TasksLiveSessionRoute,
  TasksSessionRoute: TasksSessionRoute,
  DeployIndexRoute: DeployIndexRoute,
  HeatmapIndexRoute: HeatmapIndexRoute,
  ModelIndexRoute: ModelIndexRoute,
  ModelsIndexRoute: ModelsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
  ModelModelIdMeasuringRoute: ModelModelIdMeasuringRoute,
  ModelStatisticsLabelDistributionRoute: ModelStatisticsLabelDistributionRoute,
  ModelStatisticsLabelNoiseRoute: ModelStatisticsLabelNoiseRoute,
  ModelStatisticsIndexRoute: ModelStatisticsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
